<template>
  <el-tabs
      class="settings-page">
    <el-tab-pane label="Permissions">
      <permissions-manager />
    </el-tab-pane>
    <el-tab-pane label="Feature Flags">
      <feature-flags-manager />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import FeatureFlagsManager from "./FeatureFlagsManager.vue";
import PermissionsManager from "./PermissionsManager.vue";
export default {
  name: "Settings",
  components: {
    FeatureFlagsManager,
    PermissionsManager,
  },
};
</script>
<style lang="scss">
.settings-page {
  font-size: 18px;
  margin-top: 70px;
  padding: 0px 100px;
  background: #fff;
}
</style>
